import axios from '../../../axios'

export const getYearStat = (data) => {
  return axios({
    url: '/stat/year/getYearStat',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/stat/statYear.js